import React from "react";
import { getStatusInfo, getPaymentStatusInfo } from "./session";

// Generic Badge Component
interface BadgeProps {
  text: string;
  color: string;
  Icon?: React.ComponentType<any>;
}

const Badge: React.FC<BadgeProps> = ({ text, color, Icon }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 text-[11px] sm:text-xs font-medium rounded-full ${color}`}
  >
    {Icon && <Icon className="w-3.5 h-3.5 mr-1" />}
    {text}
  </span>
);

// Status Badge
export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const { text, color, icon: Icon } = getStatusInfo(status);
  return <Badge text={text} color={color} Icon={Icon} />;
};

// Payment Badge
export const PaymentBadge: React.FC<{ isPaid: boolean }> = ({ isPaid }) => {
  const { text, color, icon: Icon } = getPaymentStatusInfo(isPaid);
  return <Badge text={text} color={color} Icon={Icon} />;
};
